export const P0003605PositionTypeEnum = [
  { ref: 0, label: 'P0003605.positiontype.0' },
  { ref: 1, label: 'P0003605.positiontype.1' },
];
